import Glide from '@glidejs/glide';


export function newsSliderSetup() {
  console.log('newsSliderSetup');
  // searches for a slide block  to attach to, if none found returns
  var newsSlider = document.querySelector(".news-slider");

  if(!newsSlider){
    return;
  }

  let glide = new Glide(newsSlider, {
      hoverpause: true,
      type: 'carousel',
      // autoplay: 3000,
      perView: 3,
      breakpoints: {
        1024: {
          perView: 2
        },
        600: {
          perView: 1
        }
      },
    });

  // starts the instance
  glide.mount();
}